const CARDS = [
  {
    icon: "ri-bill-line",
    color: "bg-primary-100 text-primary-600",
    title: "格式要规整",
    desc: "投稿需包含标题、事件描述、时间与角色等基本要素，条理清晰、段落分明，方便读者与审核快速读懂。",
  },
  {
    icon: "ri-quill-pen-fill",
    color: "bg-accent-100 text-accent-700",
    title: "字数要合适",
    desc: "建议正文控制在 300–1000 字之间。太短说不清来龙去脉，太长则容易偏离重点、拖慢过审。",
  },
  {
    icon: "ri-copyright-line",
    color: "bg-secondary-100 text-secondary-700",
    title: "原创要保证",
    desc: "只投你亲自见证或掌握的一手瓜料。搬运、洗稿、拼接他人内容均属违规，将直接取消投稿资格。",
  },
  {
    icon: "ri-mental-health-line",
    color: "bg-primary-100 text-primary-600",
    title: "版权要清晰",
    desc: "文字与配图需有合法来源。引用或配图请注明出处，涉及肖像请打码处理，避免侵犯他人权益。",
  },
  {
    icon: "ri-flag-2-fill",
    color: "bg-accent-100 text-accent-700",
    title: "审核有标准",
    desc: "真实、客观、完整是过审底线。包含辱骂、谣言、隐私泄露或违法的内容一律不通过。",
  },
  {
    icon: "ri-time-line",
    color: "bg-secondary-100 text-secondary-700",
    title: "结果有反馈",
    desc: "投稿通过或打回都会收到站内反馈。被打回的瓜料可按修改建议调整后重新提交，不重复扣分。",
  },
];

export default function Overview() {
  return (
    <section id="overview" className="scroll-mt-20 bg-background-100/60 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-sm font-medium text-primary-700">
            <i className="ri-list-check-3"></i> 投稿要求速览
          </span>
          <h2 className="mt-4 font-display text-3xl text-foreground-900 md:text-4xl">
            六条铁律，瓜前必读
          </h2>
          <p className="mt-3 text-foreground-700">
            先把吃瓜投稿的总体要求装进脑子，再往下看每一条的详细说明与示例，投稿会轻松很多。
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {CARDS.map((card, i) => (
            <article
              key={card.title}
              className="rounded-2xl border border-background-200 bg-background-50 p-6 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="flex items-start justify-between">
                <span className={`flex h-12 w-12 items-center justify-center rounded-2xl text-2xl ${card.color}`}>
                  <i className={card.icon}></i>
                </span>
                <span className="font-display text-4xl text-background-200">{String(i + 1).padStart(2, "0")}</span>
              </div>
              <h3 className="mt-4 text-lg font-bold text-foreground-900">{card.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-700">{card.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}